import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Setting up various `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Integrated_development_environment"
      }}>{`IDE`}</a>{`-like autocompleter in vim is painful until I met `}<a parentName="p" {...{
        "href": "https://github.com/autozimu/LanguageClient-neovim"
      }}>{`LanguageClient-neovim`}</a>{`.`}</p>
    <h1>{`First, Disclaimer`}</h1>
    <p>{`I've been using Shougo's completion plugin ever since neocomplete (during the ancient vim time). Now in neovim, it has its `}<a parentName="p" {...{
        "href": "https://github.com/Shougo/deoplete.nvim"
      }}>{`dark`}</a>{` form. If you are using other completion plugins like `}<a parentName="p" {...{
        "href": "https://github.com/ncm2/ncm2"
      }}>{`ncm2`}</a>{`, this post might not be the case.`}</p>
    <h1><a parentName="h1" {...{
        "href": "https://en.wikipedia.org/wiki/Language_Server_Protocol"
      }}>{`Language Server Protocol`}</a></h1>
    <p>{`If you ask what changed my impression of Microsoft, I'd answer this Language Server Protocol as one. From the `}<a parentName="p" {...{
        "href": "https://microsoft.github.io/language-server-protocol/implementors/servers/"
      }}>{`official page`}</a>{`, you could see so far many programming languages and `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Domain-specific_language"
      }}>{`DSL`}</a>{` are onboard! Even though `}<a parentName="p" {...{
        "href": "https://code.visualstudio.com/"
      }}>{`vscode`}</a>{` still takes first class seat, I'm sure we'll see more powerful standalone servers coming up. Wow, you could even get a server for `}<a parentName="p" {...{
        "href": "http://nehe.gamedev.net/article/glsl_an_introduction/25007/"
      }}>{`GLSL`}</a>{`. No complaints anymore!`}</p>
    <h1>{`So Goodbye? `}<a parentName="h1" {...{
        "href": "http://eclim.org/"
      }}>{`Eclim`}</a>{`, `}<a parentName="h1" {...{
        "href": "http://ternjs.net/"
      }}>{`Tern.js`}</a>{` and ...`}</h1>
    <p>{`That means whenever I need to work on a new language in vim, I no longer need to search that particular `}<a parentName="p" {...{
        "href": "https://github.com/Shougo/deoplete.nvim"
      }}>{`deoplete`}</a>{` plugins and make it work after hours due to dependencies and .vimrc configuration. Installing completion engine dependencies is tedious: I still remember `}<a parentName="p" {...{
        "href": "https://github.com/carlitux/deoplete-ternjs"
      }}>{`tern.js`}</a>{` was not friendly and `}<a parentName="p" {...{
        "href": "http://eclim.org/vim/code_completion.html"
      }}>{`Eclim`}</a>{` bundled with the huge `}<a parentName="p" {...{
        "href": "https://www.eclipse.org/"
      }}>{`Eclipse`}</a>{` GUI family sale is quite tough. They lack of a universal language protocol standard. Even you succeed to make it work, after, you also need to weak key bindings for each of them.`}</p>
    <p>{`Now with LanguageClient-neovim, I just install the servers (Note: not all of them are out of box but doable and only one time effort) and tell vim where their binaries are. I have freedom to choose any servers I like and freedom to pick up any editors/clients. I've tried out 4 languages so far: Java, Javascript, C++ and Python. They are working amazingly well. Let's see how much work to happiness:`}</p>
    <h2>{`Java`}</h2>
    <p>{`From the document, you feel you have to build either `}<a parentName="p" {...{
        "href": "https://github.com/eclipse/eclipse.jdt.ls/"
      }}>{`eclipse.jdt`}</a>{` or `}<a parentName="p" {...{
        "href": "https://github.com/georgewfraser/vscode-javac"
      }}>{`javac based ls`}</a>{`. However, for eclipse.jdt they have prebuilt versions to download `}<a parentName="p" {...{
        "href": "http://download.eclipse.org/jdtls/milestones/"
      }}>{`here`}</a>{`! So download and `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`untar`}</code>{`, and then follow the `}<a parentName="p" {...{
        "href": "https://github.com/autozimu/LanguageClient-neovim/wiki/Java#user-content-installation"
      }}>{`script`}</a>{`.`}</p>
    <h2>{`Python`}</h2>
    <p>{`Simply run `}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`pip `}<span parentName="code" {...{
            "className": "token function"
          }}>{`install`}</span>{` python-language-server`}</code></pre></div>
    <p>{`figure out your `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`pyls`}</code>{` binary path and you are done!`}</p>
    <h2>{`Javascript`}</h2>
    <p>{`Same as Python, you just need to `}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`npm`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`install`}</span>{` javascript-typescript-langserver`}</code></pre></div>
    <p>{`and find the binaries.`}</p>
    <h2>{`C++`}</h2>
    <p>{`If you choose clang (`}{`[which you probably do]`}{`({% post_url 2018-08-11-clang-llvm %})), you just need to install clang with extra tools in box as in this `}<a parentName="p" {...{
        "href": "https://github.com/autozimu/LanguageClient-neovim/wiki/Clangd"
      }}>{`tutorial`}</a>{`. Although signature has an `}<a parentName="p" {...{
        "href": "https://github.com/autozimu/LanguageClient-neovim/issues/379"
      }}>{`issue`}</a>{`, but I believe community will solve it soon.`}</p>
    <h1>{`To Sum Up`}</h1>
    <p>{`After installing these servers, you just need a few lines in your vim plugins settings like `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/dotfiles/blob/3b4f4473f17575eae54e554e48ba9ef78ccc1a44/neovim/nvim/config/plugins.vimrc#L257"
      }}>{`here`}</a>{`.`}</p>
    <p>{`Easy piece, right? No?! Okay, if you enjoy a bit more automation, I have a `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/dotfiles/blob/experimental/misc/installNeovimLanguageServers.sh"
      }}>{`script`}</a>{` to deploy servers in my dotfile environment, you could adapt and make it yours.`}</p>
    <h1>{`Other Finding`}</h1>
    <p>{`At this stage, even not fully convinced but I found `}<a parentName="p" {...{
        "href": "https://github.com/neoclide/coc.nvim"
      }}>{`coc.nvim`}</a>{` as yet another completion plugin seems to adapt all vscode language-service extensions to vim. If you like more vscode like features and don't have time to install each individual server, you might consider giving it a try. It seems to be still in heavy development. I chose to give it a little bit more time until I get tired of this LanguageClient plugin.`}</p>
    <p>{`Meanwhile, while we wait, neovim is working on more native lsp support `}<a parentName="p" {...{
        "href": "https://github.com/neovim/neovim/pull/6856"
      }}>{`here`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      